var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_7_3511",
    transform: "matrix(0.0138889 0 0 0.0166667 -0.0347222 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_7_3511",
    width: 77,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAAA8CAMAAAAUqcfmAAAAbFBMVEXYKhv////YJRfXIRLpY0rqaVDzvrfrj4b52dbxq6T41NDWGgrbNif99PL76ObhVEjmc2jslY3dQTPzuLL64d7++fjkZVn87+3aMSL1ysbpgXfcPC7iXFDfTT/kal/vpJzxsannem/1xsH0kHc+jVFkAAADg0lEQVRYhe2YWZOjIBCAEWaCJ95oUDRx/v9/XLrxQGN2s1WpfdhKP2TodPjS0JcT8vP1PvkhX4y+S9gX+abkXUK/P7QP7T+lMXZupMzKwYo0OoZhqBio3dUsNegopSrM20yFq1wLalhFNl4utzzTlD3Q2OR5Xo60IjHLFPRZhKKE5ZvuGUA3NrOSTAN9oF0OtIuz2xupS6s1SyvHOv0lzcsi17eiq3ZG9hLN72UvEVsRoAlupR2R4o88L4XXdK/5dsWYBbCz56BHVjq8M07A3OXBLqobTWDIfG+lUYyxgK1AqzIUPeBd2tygtH3MELa/J4dGMNwB32y5wk/sEuN12s0sby4N7jApniT1X/sG61r/iVbKwcg92dFo0Sz3llxR7hkwVWR3n1UW0niEUdrHlJRrTMN5yKXwjuixTOMxP6ms03yTg8yumFqYb+GyBd+rS5WpQBxu8PVaWGhM7ozBa7Wwylynq2+M73BuQF7vISuNsGyrVJHHRxodfd9f+ptZatBBwsvc38z6tm1i8b30RdJUYH64NxNptnRT2MxmDfoi5gkjbdwStlyRsZIi1R09Nl/rmwo20XJZ5UOL+5nmk19VYSCJzeiCT6IR1cSLQ4Ft97aIdC7Zl+bjlCeLPkE+sLtY9Iaf+LarLJfmJemu8Xp+TJlyI/ose/0S5aKBJsxqqs2ijDC9mlEpPACP0gSd6nuOLsrzfLOVZQR8uYAyGJxoAdKkYIDOGeJrLY3dcp/MhZlmT3bBbzRpJXBLDkVO4zRNdSxWM4J3peX0kAF7a7/6ht8dDstxKGZNpOH83NKwnfTsjLaEDYvSV0pxyPgcdkA7i8sJJMBrtIOKOevf0hap4rul0c6mSfUibY4pd2hJqSM8TWpodrz7KZxUOSeVp7RdFMIe2qQwVYjN8W5KS0owVAVEobS08XkUDhmCE30itIWZeDUlxTDzKgJjJ+kjSiMtnmdIaedlFnNMAYbB5Mym/q0wIc2QhkcVSus79qXhPHsXkZY2n8MMTjQ21ymEm6vauVnWNf4ZT2b9Q9VPzCQrnNEUZntzrKKlTheoc/JIo4HYpFfmBR4vmASVmzklSwGe1I3pSi10qDxs6rrxx+PIt92yjTdBBR8vqNWhfca671NdtNYV0z07rQvy8Bg7P/c6/xWiMhudFWPUncWUHiezQ3uTfGgf2j+mvffXlbf+8vMLxrJCFJ5PHzwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.23cd43ef57451da3ed95fc52d06b05ed.svg";
export { ForwardRef as ReactComponent };